import React from 'react';
import { TextFormFieldProps } from './types';
import CustomerNameField from './CustomerNameField';

const FirstNameField: React.FC<TextFormFieldProps> = ({ externalValue }: any) => {
  return (
    <CustomerNameField
      externalValue={externalValue}
      fieldMetadata={{
        id: 'first-name',
        fieldName: 'firstName',
        translationKey: 'first_name',
      }}
    />
  );
};

export default FirstNameField;
